import{styled as e}from"@mui/material/styles";const t=e("div")((({theme:e,backgroundColor:t})=>({width:48,height:48,display:"flex",justifyContent:"center",alignItems:"center",padding:e.spacing(1),borderRadius:e.spacing(2),backgroundColor:t})));export{t as IconContainerWrapper};
//# sourceMappingURL=styles.js.map
